import { kpiHasRecordedValue } from './executive-pulse-kpi-value.js';

function parseDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * @param {object} item — KPI row (value, target, startDate, …)
 * @param {object} [reportingPeriod] — `meta.reportingPeriod` from dashboard
 */
const getRAG = (item, reportingPeriod = null) => {
    const { value, target, startDate } = item ?? {};
    const isCurrentYear =
        reportingPeriod?.isCurrentYear === true ||
        reportingPeriod?.isCurrentQuarter === true;
    const isFutureYear =
        reportingPeriod?.isFutureYear === true ||
        reportingPeriod?.isFutureQuarter === true;

    const start = parseDate(startDate || reportingPeriod?.startDate);
    const periodEnd = parseDate(reportingPeriod?.endDate || item?.endDate);

    if (!kpiHasRecordedValue(item)) {
        return {
            status: 'gray',
            label: 'No data',
            expected: 0,
            actual: 0,
            variance: 0
        };
    }

    const actualProgress = Math.min(
        target ? (Number(value) / Number(target)) * 100 : 0,
        100
    );

    if (!start || !periodEnd) {
        return {
            status: 'gray',
            label: 'No timeline',
            expected: 0,
            actual: actualProgress,
            variance: 0
        };
    }

    const now = new Date();

    if (isFutureYear || now < start) {
        return {
            status: 'gray',
            label: 'Not started',
            expected: 0,
            actual: actualProgress,
            variance: 0
        };
    }

    if (!isCurrentYear) {
        const hit = actualProgress >= 100;
        return {
            status: hit ? 'green' : 'red',
            label: hit ? 'Completed' : 'Missed target',
            expected: 100,
            actual: actualProgress,
            variance: actualProgress - 100
        };
    }

    const totalDuration = periodEnd - start;
    if (totalDuration <= 0) {
        return {
            status: 'gray',
            label: 'Invalid timeline',
            expected: 0,
            actual: actualProgress,
            variance: 0
        };
    }

    const elapsed = Math.min(Math.max(now - start, 0), totalDuration);
    const expectedProgress = Math.min((elapsed / totalDuration) * 100, 100);
    const variance = actualProgress - expectedProgress;

    if (variance >= 0) {
        return {
            status: 'green',
            label: 'On track',
            expected: expectedProgress,
            actual: actualProgress,
            variance
        };
    }

    if (variance >= -10) {
        return {
            status: 'yellow',
            label: 'At risk',
            expected: expectedProgress,
            actual: actualProgress,
            variance
        };
    }

    return {
        status: 'red',
        label: 'Off track',
        expected: expectedProgress,
        actual: actualProgress,
        variance
    };
};

export default getRAG;
